import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddYurticiCargoAgreementSchemeRequest } from '../models/request/yurticiCargoAgreementScheme/AddYurticiCargoAgreementSchemeRequest';
import { GetYurticiCargoAgreementSchemeListPagingAndFilterRequest } from '../models/request/yurticiCargoAgreementScheme/GetYurticiCargoAgreementSchemeListPagingAndFilterRequest';

export class YurticiCargoAgreementSchemeService {
    static async getYurticiCargoAgreementSchemeList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getYurticiCargoAgreementSchemeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreementScheme/getYurticiCargoAgreementSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportYurticiCargoAgreementSchemeList(inputObj: GetYurticiCargoAgreementSchemeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportYurticiCargoAgreementSchemeList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreementScheme/exportYurticiCargoAgreementSchemeList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoAgreementSchemeListPagingAndFilter(inputObj: GetYurticiCargoAgreementSchemeListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetYurticiCargoAgreementSchemeListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreementScheme/GetYurticiCargoAgreementSchemeListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addYurticiCargoAgreementScheme(inputObj: AddYurticiCargoAgreementSchemeRequest) {
        try {
            console.log('SERVICE CALL - AddYurticiCargoAgreementScheme', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreementScheme/AddYurticiCargoAgreementScheme', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteYurticiCargoAgreementScheme(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteYurticiCargoAgreementScheme', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreementScheme/deleteYurticiCargoAgreementScheme', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getYurticiCargoAgreementSchemeById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getYurticiCargoAgreementSchemeById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/YurticiCargoAgreementScheme/getYurticiCargoAgreementSchemeById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}